var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('context-menu',{ref:"conf"},[_c('context-menu-item',{attrs:{"action":_vm.open}},[_c('strong',[_vm._v("Open2")])]),_c('context-menu-item',{attrs:{"action":_vm.close}},[_vm._v("\n\t\tClose\n\t")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }